<section class="cmn-innerpage-wrapper projects">
  <div class="head">
    <div class="search-wrapper">
      <input type="text" class="cmn-header-search" placeholder="Search" (input)="onSearch($event)" />
    </div>
    <button class="cmn-export-btn" (click)="toggleExport($event)">
      <img src="assets/images/icons/icon-export.svg" alt="Filter Icon" />
      <!-- <span>Export</span> -->
    </button>
    <div
      [ngClass]="{ show: isExportOpen }"
      class="common-dropdown export-position"
      #export
    >
      <button class="close-dropdown" (click)="toggleExport($event)"></button>
      <h2>Export Table</h2>

      <div class="check-wrapper">
        <div class="check-box" *ngFor="let field of fieldOptions">
          <label class="checkbox-wrapper">
            <input
              type="checkbox"
              (change)="onFieldCheckboxChange($event, field.key)"
            />{{ field.label }}
            <span class="checkmark"></span>
          </label>
        </div>
        
      </div>

      <h2>File Type</h2>

      <!-- Format Selection -->
      <div class="format-selection">
        <label class="radiobtn-wrapper">
          <input
            type="radio"
            name="exportFormat"
            value="pdf"
            [(ngModel)]="exportFormat"
          />
          <span class="radiomark"></span>
          PDF
        </label>
        <label class="radiobtn-wrapper">
          <input
            type="radio"
            name="exportFormat"
            value="csv"
            [(ngModel)]="exportFormat"
          />
          <span class="radiomark"></span>
          CSV
        </label>
      </div>

      <div class="btn-wrapper">
        <button class="cmn-apply-btn" type="submit" (click)="exportEmployees()">
          <span *ngIf="!exportLoading">Export</span>
          <span *ngIf="exportLoading">Exporting...</span>
        </button>
      </div>
    </div>
  </div>
  <div class="inner-content">
    <ag-grid-angular
      style="width: 100%"
      [rowData]="rowData"
      [columnDefs]="columnDefs"
      [defaultColDef]="defaultColDef"
      [rowSelection]="rowSelection"
      [suppressRowClickSelection]="true"
      [paginationPageSizeSelector]="paginationPageSizeSelector"
      [class]="themeClass"
      (cellClicked)="onCellClicked($event)"
      (filterChanged)="onFilterChanged()"
      (gridReady)="onGridReady($event)"
    />
  </div>
  <div class="pagination-wrapper">
    <div class="page-size">
      <label for="pageSize">Page Size:</label>
      <select
        id="pageSize"
        [(ngModel)]="pageSize"
        (change)="onPageSizeChange($event)"
      >
        <option *ngFor="let size of pageSizeOptions" [value]="size">
          {{ size }}
        </option>
      </select>
    </div>
    <div class="page-nav" *ngIf="totalPages > 1">
      <button class="prev" (click)="prevPage()" [disabled]="page === 0">
        <img
          src="../../../assets/images/icons/arrow.svg"
          alt="prev arrow"
          srcset=""
        />
      </button>
      <span> Page {{ page + 1 }} of {{ totalPages }} </span>
      <button
        class="next"
        (click)="nextPage()"
        [disabled]="page + 1 >= totalPages"
      >
        <img
          src="../../../assets/images/icons/arrow.svg"
          alt="next arrow"
          srcset=""
        />
      </button>
    </div>
  </div>
</section>
